
var Fraction = function (arg1 = null, arg2 = null, arg3 = null) {
  var whole, numerator, denominator

  /* no argument: 0 0/1 */
  if (!arg1 && !arg2 && !arg3) {
    this.sign = 1
    this.whole = 0
    this.numerator = 0
    this.denominator = 1

  /* single argument: whole 0/1 */
  } else if (!arg2 && !arg3) {
    whole = typeof arg1 === 'number' ? arg1 : parseInt(arg1)

    this.sign = whole < 0 ? -1 : 1
    this.whole = Math.abs(whole)
    this.numerator = 0
    this.denominator = 1

  /* double arguments: numerator/denominator */
  } else if (!arg3) {
    numerator = typeof arg1 === 'number' ? arg1 : parseInt(arg1)
    denominator = typeof arg2 === 'number' ? arg2 : parseInt(arg2)

    this.sign = numerator * denominator < 0 ? -1 : 1
    this.whole = 0
    this.numerator = Math.abs(numerator)
    this.denominator = Math.abs(denominator)

  /* three arguments: whole numerator/denominator */
  } else {
    whole = typeof arg1 === 'number' ? arg1 : parseInt(arg1)
    numerator = typeof arg2 === 'number' ? arg2 : parseInt(arg2)
    denominator = typeof arg3 === 'number' ? arg3 : parseInt(arg3)

    if (!numerator) this.sign = whole < 0 ? -1 : 1
    else if (!whole) this.sign = numerator * denominator < 0 ? -1 : 1
    else this.sign = whole * numerator * denominator < 0 ? -1 : 1

    this.whole = Math.abs(whole)
    this.numerator = Math.abs(numerator)
    this.denominator = Math.abs(denominator)
  }
}

Fraction.prototype.clone = function () {
  var frac = new Fraction()

  frac.sign = this.sign
  frac.whole = this.whole
  frac.numerator = this.numerator
  frac.denominator = this.denominator

  return frac
}

Fraction.prototype.convert = function (str) {
  var count = (str.match(/\//g) || []).length
  if (count > 1) return undefined

  var arr = str.split(/[\s|/]+/)
  switch (arr.length) {
    case 3:
      return new Fraction(arr[0], arr[1], arr[2])
    case 2:
      return new Fraction(arr[0], arr[1])
    case 1:
      return new Fraction(arr[0])
    default:
      return undefined
  }
}

Fraction.prototype.gcf = function (a, b) {
  a = Math.abs(a)
  b = Math.abs(b)

  var c
  while (b) {
    c = a % b; a = b; b = c
  }

  return a
}

Fraction.prototype.simplify = function () {
  var frac = new Fraction()

  frac.sign = this.sign
  frac.whole = this.whole + Math.floor(this.numerator / this.denominator)
  frac.numerator = this.numerator % this.denominator
  frac.denominator = !frac.numerator ? 1 : this.denominator

  var gcf = this.gcf(frac.numerator, frac.denominator)
  if (gcf > 1) frac.numerator = frac.numerator / gcf
  if (gcf > 1) frac.denominator = frac.denominator / gcf

  return frac
}

Fraction.prototype.isNegative = function () {
  return this.sign < 0
}

Fraction.prototype.isProper = function () {
  if (!this.numerator || !this.denominator) return false
  return !this.whole && (this.numerator < this.denominator)
}

Fraction.prototype.isImproper = function () {
  if (!this.numerator || !this.denominator) return false
  return !this.whole && (this.numerator > this.denominator)
}

Fraction.prototype.isMixed = function () {
  if (!this.numerator || !this.denominator) return false
  return this.whole && (this.numerator < this.denominator)
}

Fraction.prototype.hasWholePart = function () {
  return this.whole !== 0
}

Fraction.prototype.hasFractionPart = function () {
  return this.numerator !== 0
}

Fraction.prototype.toImproper = function () {
  var frac = new Fraction()

  frac.sign = this.sign
  frac.whole = 0
  frac.numerator = this.whole * this.denominator + this.numerator
  frac.denominator = this.denominator

  return frac
}

Fraction.prototype.toMixed = function () {
  var frac = new Fraction()

  frac.sign = this.sign
  frac.whole = this.whole + Math.floor(this.numerator / this.denominator)
  frac.numerator = this.numerator % this.denominator
  frac.denominator = this.denominator

  return frac
}

Fraction.prototype.toHTML = function () {
  var sign = this.sign < 0 ? '-' : ''

  if (!this.numerator) return sign + this.whole
  if (!this.whole) {
    return sign + '<div class="fraction">' +
    '<div class="numerator">' + this.numerator + '</div>' +
    '<div class="denominator">' + this.denominator + '</div></div>'
  }
  return sign + '<div class="whole">' + this.whole +
    '<div class="fraction"><div class="numerator">' + this.numerator + '</div>' +
    '<div class="denominator">' + this.denominator + '</div></div></div>'
}

Fraction.prototype.toString = function () {
  var sign = this.sign < 0 ? '-' : ''

  if (!this.numerator) return sign + this.whole
  if (!this.whole) return sign + this.numerator + '/' + this.denominator
  return sign + this.whole + ' ' + this.numerator + '/' + this.denominator
}

Fraction.prototype.equals = function (frac) {
  if (typeof frac === 'string') frac = this.convert(frac)
  if (typeof frac === 'undefined') return false

  if (!this.denominator || !frac.denominator) return false

  // equals here means identical, not equivalent
  return (
    this.sign === frac.sign &&
    this.whole === frac.whole &&
    this.numerator === frac.numerator &&
    this.denominator === frac.denominator
  )
}

Fraction.prototype.compare = function (frac) {
  var a = this.sign * (this.whole * this.denominator + this.numerator) * frac.denominator
  var b = frac.sign * (frac.whole * frac.denominator + frac.numerator) * this.denominator

  // compare numerators
  return a > b ? 1 : (a === b ? 0 : -1)
}

Fraction.prototype.add = function (frac) {
  var a = this.sign * (this.whole * this.denominator + this.numerator) * frac.denominator
  var b = frac.sign * (frac.whole * frac.denominator + frac.numerator) * this.denominator

  return new Fraction(a + b, this.denominator * frac.denominator).simplify()
}

Fraction.prototype.sub = function (frac) {
  var a = this.sign * (this.whole * this.denominator + this.numerator) * frac.denominator
  var b = frac.sign * (frac.whole * frac.denominator + frac.numerator) * this.denominator

  return new Fraction(a - b, this.denominator * frac.denominator).simplify()
}

Fraction.prototype.mul = function (frac) {
  var a = this.sign * (this.whole * this.denominator + this.numerator)
  var b = frac.sign * (frac.whole * frac.denominator + frac.numerator)

  return new Fraction(a * b, this.denominator * frac.denominator).simplify()
}

Fraction.prototype.div = function (frac) {
  var a = this.sign * (this.whole * this.denominator + this.numerator)
  var b = frac.sign * (frac.whole * frac.denominator + frac.numerator)

  return new Fraction(a * frac.denominator, b * this.denominator).simplify()
}

Fraction.prototype.pow = function (power) {
  var a = this.sign * (this.whole * this.denominator + this.numerator)
  var b = this.denominator

  return new Fraction(Math.pow(a, power), Math.pow(b, power)).simplify()
}

export default Fraction



// WEBPACK FOOTER //
// ./src/math/types/fraction.js